import styled from 'styled-components'
import {media} from '../../util';
import {COLOR, SIZE} from '../../const';
import IconPullDown from '../../assets/images/pulldown.svg';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  border-top: 1px solid #ddd;
`
export const KeyWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: ${COLOR.main};
  padding: 10px;
  ${media.pc`flex-basis: 50%;`}
  ${media.tablet`flex-basis: 40%;`}
  ${media.phone`flex-basis: 100%;`}
`
export const Title = styled.div<{required?: boolean}>`
  width: 100%;
  color: white;
  font-weight: bold;
  font-size: ${SIZE.font_large};
  &:after {
    color: #f00;
    content: " ${props => props.required ? "(必須)" : ""}"
  }
`
export const Caution = styled.div`
  font-weight: bold;
  color: #f00;
`
export const Content = styled.div<{error?: boolean}>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: auto;
  background-color: ${(props) => props.error ? "#f00" : "#e3ffe3"};
  ${media.pc`flex-basis: 50%;`}
  ${media.tablet`flex-basis: 60%;`}
  ${media.phone`flex-basis: 100%;`}
  & > input, & > select {
    font-size: ${SIZE.font_large};
    padding: 10px;
    border: 0px solid #000;
    border-bottom: 1px solid #aaa;
    color: ${COLOR.black};
    background-color: #white;
  }
  & > select {
    background-image: url(${IconPullDown});
    background-position: right 10px center;
    background-repeat: no-repeat;
    background-size: 20px 20px;
    -webkit-appearance: none;
    appearance: none;
  }
`
